import React, { useEffect, useState, useMemo, useRef } from 'react';
import styles from "./bannerComp.module.css"
import { fetchBanner,openCustomUrl } from "../Values/utils";
import { googleAnalytics,pushToGA } from "../Services/users";
import { connect, useDispatch} from "react-redux";
import WhatsappBannerImage from '../Assets/Images/whatsapp-banner.png';
import WhatsappFreeTrialBannerImage from '../Assets/Images/whatsapp-free-trial-banner.png';



interface HtmlBannerProps {
  bannerType?:any,
  user:any,
  setShowGenericPopupContent?: (val: boolean) => void;
  route?:any,
  setShow?: (val: boolean) => void;
  key?:any,
  agentReversefeedbackhandler?:(val:any) => void,
  organization?:any,
  isUsingApp?:boolean,
  tagObj?:any
   setCheckBannerActive?: (val: boolean) => void;
}

const HtmlBanner: React.FC<HtmlBannerProps> = ({bannerType,user,setShowGenericPopupContent,route,setShow,key,agentReversefeedbackhandler,organization ,isUsingApp,tagObj,setCheckBannerActive}) => {
  const bannerHtmlList:any = [
    `<div style="background: yellow; padding: 10px;">
      <h2>🔥 Flash Sale Today Only!</h2>
      <a href="https://example.com/sale">Shop Now</a>
    </div>`,
    `<div style="background: lightblue; padding: 10px;">
      <h2>🎁 Exclusive Offer: Buy 1 Get 1 Free!</h2>
      <a href="https://example.com/offer">Claim Now</a>
    </div>`,
    `<div style="background: lightgreen; padding: 10px;">
      <h2>📢 Big Announcement!</h2>
      <a href="https://example.com/news",target:"_blank">Read More</a>
    </div>`
  ];

  // const [bannerData,setBannerData]= useState<any>([])
  const [currentBanner, setCurrentBanner] = useState<any>([]);
  const [autoToken, setAutoToken] = useState("");
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const htmlBannerRef = useRef<HTMLDivElement>(null);
  const [landingUrl, setLandingUrl] = useState("");

  // Memoize HTML content to avoid unnecessary recalculation
  const htmlContent = useMemo(() => {
    const banner = currentBanner?.[0];
             const dataLayerSnippet = `
         window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'event_tracking',
          eventName: 'read pro',
          eventCategory: 'read pro',
          eventAction: '${currentBanner[0]?.ctaGA} click',
          eventLabel: '${currentBanner[0]?.impressionGA}'
        });
    `;
    if (!banner || banner.bannerContentType !== "HTML") return "";
    let content = banner.renderingContent;
    if (banner.landingPageUrl && !banner.autoLogin) {
     

      content = content.replace(
        /<button([^>]*)>/i,
        `<button$1 onclick=\"${dataLayerSnippet} window.open('${banner.landingPageUrl}', '_blank')\">`
      );
    }
    if (banner.landingPageUrl && banner.autoLogin === true) {
      content = content.replace(
        /<button([^>]*)>/i,
        `<button$1 onclick=\"${dataLayerSnippet} window.open('${openCustomUrl(autoToken, banner.landingPageUrl)}', '_blank')\">`
      );
    }
    return content;
  }, [currentBanner, autoToken]);

  useEffect(() => {
    let userData: any = localStorage.getItem("user");
    let parsedUser = JSON.parse(userData);
    if (parsedUser.autoToken) {
      setAutoToken(parsedUser.autoToken)
    }
  }, [])


useEffect(() => {
  const fetchData = async () => {
    try {
      const storageKey = `bannerIndex-${route}-${bannerType}`;
      let currentIndex = parseInt(localStorage.getItem(storageKey) || "0");

      if (bannerType && route) {
        const data: any = await fetchBanner(bannerType, currentIndex, route,tagObj || {});
        console.log("Data", data);

        if (data?.data && typeof data.size === "number") {
          // Reset banner if index exceeds size
          if (currentIndex >= data.size) {
            currentIndex = 0;
          }

          const nextIndex = (currentIndex + 1) % data.size;
          localStorage.setItem(storageKey, nextIndex.toString());
           if(bannerType==="contactMidView"){setCheckBannerActive?.(true);}
          setCurrentBanner([data.data]);
          setShow?.(false);
          setShowGenericPopupContent?.(true);
        } else {
          setShowGenericPopupContent?.(false);
          setShow?.(true);
           if(bannerType==="contactMidView"){setCheckBannerActive?.(false);}
        }
      }
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  fetchData();
}, [route, bannerType]);


  

useEffect(() => {
  if (currentBanner && currentBanner.length > 0) {
    const banner = currentBanner[0];

        const dataLayerSnippet = `
         window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'event_tracking',
          eventName: 'read pro',
          eventCategory: 'read pro',
          eventAction: '${currentBanner[0]?.ctaGA} click',
          eventLabel: '${currentBanner[0]?.impressionGA}'
        });
    `;

    // Case 1: Normal landing page
    if (banner.landingPageUrl && banner.bannerContentType === "HTML" && !banner.autoLogin) {
      banner.renderingContent = banner.renderingContent.replace(
        /<button([^>]*)>/i,
        `<button$1 onclick="${dataLayerSnippet} window.open('${banner.landingPageUrl}', '_blank')">`
      );
    }

    // Case 2: Auto-login required
    if (banner.landingPageUrl && banner.bannerContentType === "HTML" && banner.autoLogin === true) {
      banner.renderingContent = banner.renderingContent.replace(
        /<button([^>]*)>/i,
        `<button$1 onclick="${dataLayerSnippet} window.open('${openCustomUrl(autoToken,banner.landingPageUrl)}', '_blank')">`
      );
    }
  }
}, [currentBanner, autoToken]);


  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile && currentBanner.length>0 && currentBanner[0].impressionGA){
        setIsGACalled(true)
        googleAnalytics(`${currentBanner[0].impressionGA}`,user)
      }
    }
  },[user,currentBanner])


useEffect(() => {
  const banner = currentBanner?.[0];
  const container = htmlBannerRef.current;

  // ✅ Only run when container and all banner data are present
  if (
    container &&
    banner &&
    banner.bannerContentType === "HTML" &&
    htmlContent &&
    banner.impressionGA &&
    banner.ctaGA &&
    user
  ) {

    console.log("container",container)
    const scripts = container.querySelectorAll("script");
    scripts.forEach((oldScript) => {
      const newScript = document.createElement("script");
      newScript.text = oldScript.innerText || oldScript.textContent || "";

      Array.from(oldScript.attributes).forEach((attr) =>
        newScript.setAttribute(attr.name, attr.value)
      );

      oldScript.parentNode?.replaceChild(newScript, oldScript);
    });

    // const link = container.querySelector("a");
    // const handleClick = () => {
    //   pushToGA(
    //     "event_tracking",
    //     "read pro",
    //     "read pro",
    //     `${banner.impressionGA} click`,
    //     user,
    //     `${banner.ctaGA}`
    //   );
    // };

    // if (link) {
    //   link.addEventListener("click", handleClick);
    // }

    // return () => {
    //   if (link) {
    //     link.removeEventListener("click", handleClick);
    //   }
    // };
  }
}, [
  htmlContent,
  currentBanner?.[0]?.bannerContentType,
  currentBanner?.[0]?.impressionGA,
  currentBanner?.[0]?.ctaGA,
  user,
]);

  useEffect(()=>{
    if( currentBanner &&
      currentBanner.length > 0 && user.user_oid && currentBanner[0]?.landingPageUrl){
      setLandingUrl(currentBanner[0]?.landingPageUrl)
    }
  },[currentBanner,user])


  
//  console.log("landingUrl",currentBanner[0]?.renderingContent)
  
  return (
    <>
      {user?.user_oid &&currentBanner&&
        currentBanner?.map((val: any, index: number) => {
          if (val.bannerContentType === "image" ) {
            return (
              <div
                key={index}
               className={
  bannerType === "footerPopup"
    ? `${styles.Hitbbanner} ${styles.footerPopup}`
    : bannerType === "contactSideView"
    ? `${styles.Hitbbanner} ${styles.sideview}`
    :  bannerType === "contactMidView"
    ?   `${styles.Hitbbanner} ${styles.midView}`
    :`${styles.Hitbbanner} ${styles.ProjectListingBanner}`
}

                onClick={() => {
                  pushToGA(
                    "event_tracking",
                    "read pro",
                    "read pro",
                    `${val.impressionGA} click`,
                    user,
                    `${val.ctaGA}`
                  );

                  if (val.name==="Agent_Reverse_Feedback_Banner") {
                    try {
                       agentReversefeedbackhandler && agentReversefeedbackhandler("a");
                    } catch (error) {
                      console.error("Error executing val.fun:", error);
                    }
                  }else if (val.name==="Whatsapp_Banner"){
                    try {
                       agentReversefeedbackhandler && agentReversefeedbackhandler("w");
                    } catch (error) {
                      console.error("Error executing val.fun:", error);
                    }      
                  }
      
                }}
              >
                {val.disableLink ? (
                  <img
                    className={styles.HitBannerImage}
                    src={val.name === "Whatsapp_Banner"
                      ? organization.WhatsAppTrialPack === true
                        ? WhatsappFreeTrialBannerImage
                        : WhatsappBannerImage
                      : val.renderingContent}

                    alt="ProjectListingBanner"
                    width="100%"
                  />
                ) : (
                  <a
                    href={
                      val.autoLogin === false
                        ? `${landingUrl}`
                        : `${openCustomUrl(autoToken,landingUrl)}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      className={styles.HitBannerImage}
                      src={val.renderingContent}
                      alt="ProjectListingBanner"
                      width="100%"
                    />
                  </a>
                )}

              </div>
            );
          } else if (val.bannerContentType === "HTML") {
            return (
              <div
                key={index}
                className={bannerType==="popup"?styles.htmlBannerpop:bannerType === "contactSideView"?styles.sideview:bannerType === "contactMidView"
    ?   ` ${styles.midView}`:styles.htmlbanner}
                ref={htmlBannerRef}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            );
          }else{
            <></>
          } 
        })}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organization: state.organization,
    isUsingApp: state.user.isUsingApp,
    hasActiveWAPackage: state.organization.hasActiveWAPackage,
  };
};

export default connect(mapStateToProps)(HtmlBanner);